export enum FormGuidEnum {
    'SIG_USER_REQUEST' = 'a1e1b41c-15f3-11ec-9685-acde48001122',
    'QUESTION' = '173e687e-30aa-11ec-811b-acde48001122',
}
